module.exports = __webpack_public_path__ + "img/007.fe3b46ed.jpg";